import { API_ENDPOINTS } from '../endpoints';
import { getAuthHeaders, handleResponse } from '../client';
import type { CalendarDayVO, CalendarInitDTO, CalendarUpdateDTO } from '../types';

export const calendarApi = {
  /** 单月：传 month；多年一条请求：传 toYear（与 year 组成闭区间，含端点） */
  getList: async (params: { year: number; month?: number; toYear?: number }): Promise<CalendarDayVO[]> => {
    const query = new URLSearchParams();
    query.set('year', String(params.year));
    if (params.month) query.set('month', String(params.month));
    if (params.toYear != null && params.toYear > 0 && !params.month) query.set('toYear', String(params.toYear));
    const response = await fetch(`${API_ENDPOINTS.CALENDAR.LIST}?${query.toString()}`, {
      headers: getAuthHeaders(),
    });
    return handleResponse<CalendarDayVO[]>(response);
  },

  initYear: async (data: CalendarInitDTO): Promise<boolean> => {
    const response = await fetch(API_ENDPOINTS.CALENDAR.INIT, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    });
    await handleResponse<unknown>(response);
    return true;
  },

  update: async (id: number, data: CalendarUpdateDTO): Promise<CalendarDayVO> => {
    const response = await fetch(API_ENDPOINTS.CALENDAR.UPDATE(id), {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    });
    return handleResponse<CalendarDayVO>(response);
  },
};
